import { aggregateStats } from '../../../mocks/caseStudies';

export default function AggregateStats() {
  return (
    <section className="pt-12 pb-20 px-6 bg-stone-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-4">
            Proven Impact
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-wide">
            Results Across Every Operation
          </h2>
          <p className="text-xl text-gray-700 font-light max-w-2xl mx-auto">
            Combined outcomes from the farmers and landowners we work with.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {aggregateStats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 text-center shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-5xl text-emerald-800`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-emerald-800 mb-2">
                {stat.metric}
              </div>
              <p className="text-gray-700 font-semibold text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
